import { buildModelManager } from "../builder.js";
const DefaultWhatsappPartnerWebhookSelection = {
  __typename: true,
  id: true,
  createdAt: true,
  data: true,
  isFromWhatsappDirectly: true,
  isProcessed: true,
  updatedAt: true
};
const modelApiIdentifier = "whatsappPartnerWebhook";
const pluralModelApiIdentifier = "whatsappPartnerWebhooks";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultWhatsappPartnerWebhookSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultWhatsappPartnerWebhookSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultWhatsappPartnerWebhookSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultWhatsappPartnerWebhookSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultWhatsappPartnerWebhookSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultWhatsappPartnerWebhookSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultWhatsappPartnerWebhookSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createWhatsappPartnerWebhook",
    operationReturnType: "CreateWhatsappPartnerWebhook",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      whatsappPartnerWebhook: { required: false, type: "CreateWhatsappPartnerWebhookInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultWhatsappPartnerWebhookSelection
  },
  {
    type: "action",
    operationName: "bulkCreateWhatsappPartnerWebhooks",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkCreateWhatsappPartnerWebhooksInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultWhatsappPartnerWebhookSelection
  },
  {
    type: "action",
    operationName: "updateWhatsappPartnerWebhook",
    operationReturnType: "UpdateWhatsappPartnerWebhook",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      whatsappPartnerWebhook: { required: false, type: "UpdateWhatsappPartnerWebhookInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultWhatsappPartnerWebhookSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateWhatsappPartnerWebhooks",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpdateWhatsappPartnerWebhooksInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultWhatsappPartnerWebhookSelection
  },
  {
    type: "action",
    operationName: "deleteWhatsappPartnerWebhook",
    operationReturnType: "DeleteWhatsappPartnerWebhook",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteWhatsappPartnerWebhooks",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertWhatsappPartnerWebhook",
    operationReturnType: "UpsertWhatsappPartnerWebhook",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      whatsappPartnerWebhook: { required: false, type: "UpsertWhatsappPartnerWebhookInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateWhatsappPartnerWebhookResult": { hasReturnType: false },
      "... on UpdateWhatsappPartnerWebhookResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultWhatsappPartnerWebhookSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertWhatsappPartnerWebhooks",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpsertWhatsappPartnerWebhooksInput!]"
      }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultWhatsappPartnerWebhookSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "whatsappPartnerWebhookGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const WhatsappPartnerWebhookManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultWhatsappPartnerWebhookSelection,
  operations
);
export {
  DefaultWhatsappPartnerWebhookSelection,
  WhatsappPartnerWebhookManager
};
//# sourceMappingURL=WhatsappPartnerWebhook.js.map
